<div class="h-[calc(100vh-60px)]">
  <div class="flex flex-column gap-2 color-grey-7 py-4 h-full">
    <a [routerLink]="['/']" (click)="onOpenFeed()" routerLinkActive="text-red-500! font-bold" [routerLinkActiveOptions]="{exact: true}"
       class="panel px-3 py-3 flex flex-row ai-center gap-3">
      <sens-icon icon="#icon-faps" [size]="24"/>
      Faps
    </a>
    <a [routerLink]="['/profile']" routerLinkActive="text-red-500! font-bold" [routerLinkActiveOptions]="{exact: true}"
       class="panel px-3 py-3 flex flex-row ai-center gap-3">
      <sens-icon icon="#icon-user-circle" [size]="24"/>
      Profile
    </a>

    <sens-subscribe-banner class="mb-3"/>

    <div class="mt-auto">
      <p class="text-sm text-[#8799B2] flex flex-row gap-2 mb-2 ">
        <a [routerLink]="['/documents']">Documents</a>
        <a [routerLink]="['/documents', 'terms']">Terms</a>
        <a [routerLink]="['/documents', 'privacy']">Privacy</a>
        <a [routerLink]="['/documents', 'contact']">Contact</a>
      </p>

      <p class="text-xs text-[#8799B2]">
        AI-generated content. Not real people.
      </p>
    </div>


    <p class="text-xs text-[#8799B2]">
      © 2026 SENS LTD. Seychelles, registration number 239563. <br>All rights reserved.
    </p>
  </div>
</div>


